import React from 'react'
import { Field, reduxForm } from 'redux-form';

const form = reduxForm({
  form: 'observationsForm',
});


class ObservationsForm extends React.Component {

  render() {
    return (
      <form>
        <div className="form-group">
          <Field name="observations" component="textarea" type="text" placeholder="Cualquier información adicional que consideres que ayudará a precisar tu presupuesto." className="form-control serviceComment" rows="5"/>
        </div>
      </form>
    )
  }
}

export default form(ObservationsForm);


// WEBPACK FOOTER //
// ./src/workflow/checkout/services/observationsForm.component.js